export function err (...errs) {
  errs.forEach(err => {
    if (typeof err === 'string') {
      console.error(`%c${err}`, "font-size:18px")
    } else {
      console.error(err)
    }
  })
}

export function upperFirst(str) {  
  return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());  
}